// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27O12","left":"styles_left__3Q_rC"};